import { render } from "./BirthRecordRegister.vue?vue&type=template&id=75da807a"
import script from "./BirthRecordRegister.vue?vue&type=script&lang=js"
export * from "./BirthRecordRegister.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__